export class SearchHarnessController {
  public searchText: string;
  public lastSearchText: string;

  public onChange(searchText: string) {
    console.info(`Typing...  ${searchText}`);
  }

  public onSearch(searchText: string) {
    console.info(`Typed...  ${searchText}`);
    this.lastSearchText = this.searchText;
  }
}
